import * as React from 'react'
import PropTypes from 'prop-types'
import Show from '../components/show'
import Alert from '../components/alert'
import { toCurrencyDecimal } from '../util'
import { withStatus } from '../../common/modules/status'
import { withSubmission } from '../../common/modules/submission'
import { withQuoteSupport } from '../../common/modules/quote-support'
import "./summary-price.css"


@withStatus
@withSubmission
@withQuoteSupport
export default class extends React.Component<any, any>{

    static propTypes = {
        referred: PropTypes.bool,
        totalPayable: PropTypes.number,
        basePremium: PropTypes.number,
        levies: PropTypes.number,
        stampDuty: PropTypes.number,
        gst: PropTypes.number,
        adminFee: PropTypes.number,
        brokerFee: PropTypes.number,
        commission: PropTypes.number,
        commissionGst: PropTypes.number,
        summaryText: PropTypes.string,
        indicativePrice: PropTypes.bool.isRequired,
        indicativePriceText: PropTypes.string,
        referrals: PropTypes.object,
    }


    constructor(props){
        super(props);
        this.state = {
            collapsed:true
        }
    }


    toggleCollapse(){
        this.setState({
            collapsed: !this.state.collapsed
        })
    }


    onEmailSuccess(){
        this.props.actions.status.showMessage("Quote Emailed", (
            <div>
                <p>We have emailed a copy of your quotation to you as requested.</p>
                <p>If you don't receive our email, please check your junk or spam folders.</p>
            </div>
        ), false);
    }


    onEmailClicked(){
        const endpoint = this.props.quoteSupport.endpoints.email;
        const data = {
            type: "Quote"
        }

        this.props.actions.submission.post(endpoint, this.onEmailSuccess.bind(this), data);
    }


    render(){
        const { 
            referred,
            totalPayable,
            basePremium,
            levies,
            stampDuty,
            gst,
            adminFee,
            brokerFee,
            commission,
            commissionGst,
            summaryText,
            indicativePrice,
            indicativePriceText,
            referrals,
        } = this.props;

        const collapsed = this.state.collapsed;

        return (
            <div className="col-12">
                <div className="summary-price-info white-text">
                    <Show if={ !referred }>
                        <div className="summary-price-top d-sm-flex justify-content-start">
                            <h2 className="mr-auto"><strong>Here's your price</strong></h2>
                            <div className="text-sm-right">
                                <div><h2 className="d-inline"><strong>${ toCurrencyDecimal(totalPayable) }</strong></h2> <button className="btn btn-clear btn-circle ml-1" onClick= { this.toggleCollapse.bind(this) }><i className={"fa fa-chevron-" + (collapsed ? "down" : "up")} aria-hidden="true"></i></button></div>
                                { !collapsed && 
                                <div id="extra-info">
                                    <strong>
                                        <span>Base Premium: ${ basePremium == '0'? '0.00' : toCurrencyDecimal(basePremium) } <br/></span>
                                        
                                        { levies != null &&
                                            <span>Levies: ${ levies == '0'? '0.00' : toCurrencyDecimal(levies) }<br/></span>
                                        }
                                        
                                        { gst != null && 
                                            <span>GST: ${ gst == '0'? '0.00' : toCurrencyDecimal(gst) } <br/></span>
                                        }

                                        { stampDuty != null &&
                                            <span>Stamp duty: ${ stampDuty == '0'? '0.00' : toCurrencyDecimal(stampDuty) } <br/></span>
                                        }
                                        
                                        { adminFee != null &&
                                            <span>Admin fee:  ${ adminFee == '0'? '0.00' : toCurrencyDecimal(adminFee) } <br/></span>
                                        }

                                        { (brokerFee != null && brokerFee != '0') &&
                                            <span>Broker fee:  ${ toCurrencyDecimal(brokerFee) } <br/></span>
                                        }

                                        { commission != null &&
                                            <span>Commission: ${ commission == '0'? '0.00' : toCurrencyDecimal(commission) } <br/></span>
                                        }
                                        
                                        { commissionGst != null &&
                                            <span>Commission GST: ${ commissionGst == '0'? '0.00' : toCurrencyDecimal(commissionGst) } <br/></span>
                                        }
                                    </strong>

                                </div>
                                }
                            </div>
                        </div>
                        <div className="summary-price-bottom mt-4 d-flex align-items-start">
                            <strong><p>Refer to Important Information for Duty of Disclosure and Excess Descriptions. Please refer to Product Disclosure Statement and Policy Wording.</p></strong>
                            <button className="btn btn-clear btn-large ml-4 btn-lg" onClick={ this.onEmailClicked.bind(this) }><i className="fa fa-envelope-o" aria-hidden="true"></i> Email quote</button>
                        </div>

                        <Alert show={ summaryText != null }>{ summaryText }</Alert>
                        
                    </Show>

                    <Show if={ referred }>
                        <strong>
                            <h2><b>We're sorry, we can't give you a price just yet...</b></h2>
                            <Show if={referrals && referrals.REFERENCECODE}>
                                <h4 className="pt-2"> Our Underwriting Team would like to review your request to ensure that you are getting the best possible quote as part of our partnering with Collective Insurance Brokers. </h4>
                            </Show>
                            <h5 className="pt-2"><b>A sales representative will contact you within the next business day to discuss your quote.</b></h5>
                            <p className="pt-2">Please refer to Important Information for Duty of Disclosure and Excess Descriptions; and to the Product Disclosure Statement and Policy Wording.</p>
                        </strong>
                    </Show>

                        <Show if={ indicativePrice  }>
                        <div className="summary-price-top d-sm-flex justify-content-start">
                            <h2 className="mr-auto"><strong>Here's your Indicative price</strong></h2>
                            <div className="text-sm-right">
                                <div><h2 className="d-inline"><strong>${ toCurrencyDecimal(totalPayable) }</strong></h2> <button className="btn btn-clear btn-circle ml-1" onClick= { this.toggleCollapse.bind(this) }><i className={"fa fa-chevron-" + (collapsed ? "down" : "up")} aria-hidden="true"></i></button></div>
                                { !collapsed && 
                                <div id="extra-info">
                                    <strong>
                                        <span>Base Premium: ${ basePremium == '0'? '0.00' : toCurrencyDecimal(basePremium) } <br/></span>
                                        
                                        { levies != null &&
                                            <span>Levies: ${ levies == '0'? '0.00' : toCurrencyDecimal(levies) }<br/></span>
                                        }
                                        
                                        { gst != null && 
                                            <span>GST: ${ gst == '0'? '0.00' : toCurrencyDecimal(gst) } <br/></span>
                                        }

                                        { stampDuty != null &&
                                            <span>Stamp duty: ${ stampDuty == '0'? '0.00' : toCurrencyDecimal(stampDuty) } <br/></span>
                                        }
                                        
                                        { adminFee != null &&
                                            <span>Admin fee:  ${ adminFee == '0'? '0.00' : toCurrencyDecimal(adminFee) } <br/></span>
                                        }

                                        { (brokerFee != null && brokerFee != '0') &&
                                            <span>Broker fee:  ${ toCurrencyDecimal(brokerFee) } <br/></span>
                                        }

                                        { commission != null &&
                                            <span>Commission: ${ commission == '0'? '0.00' : toCurrencyDecimal(commission) } <br/></span>
                                        }
                                        
                                        { commissionGst != null &&
                                            <span>Commission GST: ${ commissionGst == '0'? '0.00' : toCurrencyDecimal(commissionGst) } <br/></span>
                                        }
                                    </strong>

                                </div>
                                }
                            </div>
                        </div>
                        <div className="summary-price-bottom mt-4 align-items-start">
                            <strong><p>{indicativePriceText}</p></strong><br></br>
                            <strong><p>Refer to Important Information for Duty of Disclosure and Excess Descriptions. Please refer to Product Disclosure Statement and Policy Wording.</p></strong>
                        </div>

                        <Alert show={ summaryText != null }>{ summaryText }</Alert>
                        
                    </Show>

                    
                </div>
            </div>
        )
    }


}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/summary-price.tsx